import { Text, View } from '@react-pdf/renderer';

import { COMMENTARY_TEXT } from '../../commentary/consts.ts';
import { CommentarySection } from '../components/CommentarySection.tsx';
import { CompTypeBadge } from '../components/CompTypeBadge.tsx';
import { Table } from '../components/Table.tsx';
import { Tkv2PDFPage } from '../components/Tkv2PDFPage.tsx';
import { fontStyles, priorSalesPageStyles } from '../styles.ts';
import { PriorSalesPageProps } from '../types.ts';

export const PriorSalesPage = ({
  subjectAddress,
  commentaryV2,
  compSequence,
  priorSales,
  compTypes,
}: PriorSalesPageProps) => {
  const { title } = COMMENTARY_TEXT['prior-sales'];

  return (
    <Tkv2PDFPage title={title} address={subjectAddress}>
      <CommentarySection
        title="Prior Sales Commentary"
        commentary={commentaryV2.priorSales?.commentary}
      />

      <View style={{ height: 8 }} />

      {['subject', ...compSequence].map((id, i) => {
        const propertyPriorSales = priorSales[id];
        const propertyTitle = id === 'subject' ? 'Subject' : `Comparable ${i}`;

        const compType = compTypes[id];
        const propertyTitleElement = (
          <View style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 4 }}>
            <Text style={fontStyles.bodyBold}>{propertyTitle}</Text>
            {compType && <CompTypeBadge compType={compType} fullText compact />}
          </View>
        );

        if (!propertyPriorSales || propertyPriorSales.length === 0) {
          return (
            <View key={id} style={priorSalesPageStyles.propertyBlock}>
              {propertyTitleElement}
              <Text style={fontStyles.bodyLight}>No prior sales data available.</Text>
            </View>
          );
        }

        return (
          <View key={id} style={priorSalesPageStyles.propertyBlock}>
            {propertyTitleElement}
            <Table>
              <Table.Column>
                <Table.TextCell>Data Source(s)</Table.TextCell>
                {propertyPriorSales.map((_, idx) => (
                  <Table.TextCell key={`${id}-src-${idx}`}>MLS</Table.TextCell>
                ))}
              </Table.Column>
              <Table.Column>
                <Table.TextCell>Prior Sale Date</Table.TextCell>
                {propertyPriorSales.map((row, idx) => (
                  <Table.TextCell key={`${id}-close-${idx}`}>{row.CloseDate}</Table.TextCell>
                ))}
              </Table.Column>
              <Table.Column>
                <Table.TextCell>Prior Sale Price</Table.TextCell>
                {propertyPriorSales.map((row, idx) => (
                  <Table.TextCell key={`${id}-price-${idx}`}>{row.ClosePrice}</Table.TextCell>
                ))}
              </Table.Column>
              <Table.Column>
                <Table.TextCell>Prior Listing Date</Table.TextCell>
                {propertyPriorSales.map((row, idx) => (
                  <Table.TextCell key={`${id}-listd-${idx}`}>
                    {row.ListingContractDate}
                  </Table.TextCell>
                ))}
              </Table.Column>
              <Table.Column>
                <Table.TextCell>Prior Listing Price</Table.TextCell>
                {propertyPriorSales.map((row, idx) => (
                  <Table.TextCell key={`${id}-listp-${idx}`}>{row.ListPrice}</Table.TextCell>
                ))}
              </Table.Column>
            </Table>
          </View>
        );
      })}
    </Tkv2PDFPage>
  );
};
